import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class InsuranceConciliationService {
  constructor(private http: HttpClientService) {}

  public getInsurancesConciliationsByStatus(filters): Observable<any> {
    const options = {
      params: filters,
    };
    return this.http
      .get("/api/insurance_conciliations/search_by_status", options)
      .pipe(tap((_) => console.log("InsuranceService.getInsurancesConciliationsByStatus: Ok.")));
  }

  public processData(content): Observable<any> {
    return this.http
      .post("/api/insurance_conciliations/process_data", { content })
      .pipe(tap((_) => console.log("InsuranceConciliationService.processData: Ok.")));
  }

  public notifyConciliation(params: any): Observable<any> {
    return this.http
      .post("/api/insurance_conciliations/notify_conciliation", params)
      .pipe(tap((_) => console.log("InsuranceConciliationService.notifyConciliation: Ok.")));
  }

  updateInsuranceConciliation(insurance_conciliation: any) {
    const options = {
      insurance_conciliation: insurance_conciliation,
    };
    return this.http
      .put("/api/insurance_conciliations/" + insurance_conciliation.id, options)
      .pipe(tap((_) => console.log("InsuranceConciliationService.updateInsuranceConciliation: Ok.")));
  }

  public getApprovedInsuranceConciliationCsv(): Observable<any> {
    const options = {
      responseType: "blob" as "json",
    };
    return this.http
      .get("/api/insurance_conciliations/approved_to_csv", options)
      .pipe(tap((_) => console.log("InsuranceService.getApprovedInsuranceConciliationCsv: Ok.")));
  }
}
